import { financialAdviceLinks } from '../../data/financial-advice/financial-advice-links';
import { getDefaultData } from '../../data/financial-advice/get-default-data';
import {
  AllProductsButton,
  LinksColumnTitle,
  LinksContainer,
  LinksSubContainer,
  NavLink,
  SectionSubTitle,
  SectionTitle,
  TitleContainer,
} from '../HeaderSubmenuMobile.style';
import { navigation } from '@exploration/cms-constants';

export const FinancialAdviceMobileMenu = () => {
  const cmsData = getDefaultData();

  const arrowSVG = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g xmlns="http://www.w3.org/2000/svg" id="Arrow Right">
          <path
            id="icon"
            d="M3.33335 8.66669H10.78L7.52669 11.92C7.26669 12.18 7.26669 12.6067 7.52669 12.8667C7.78669 13.1267 8.20669 13.1267 8.46669 12.8667L12.86 8.47335C13.12 8.21335 13.12 7.79335 12.86 7.53335L8.47335 3.13335C8.21335 2.87335 7.79335 2.87335 7.53335 3.13335C7.27335 3.39335 7.27335 3.81335 7.53335 4.07335L10.78 7.33335H3.33335C2.96669 7.33335 2.66669 7.63335 2.66669 8.00002C2.66669 8.36669 2.96669 8.66669 3.33335 8.66669Z"
            fill="#BE1D3D"
          />
        </g>
      </svg>
    );
  };

  return (
    <>
      <TitleContainer>
        <SectionTitle>
          {
            cmsData?.text?.[
              navigation.financial_advice_navigation_links
                .financial_advice_title
            ]
          }
        </SectionTitle>
        <SectionSubTitle>
          {
            cmsData?.text?.[
              navigation.financial_advice_navigation_links
                .financial_advice_description
            ]
          }
        </SectionSubTitle>
        <AllProductsButton
          href={financialAdviceLinks.bankingNavigationalLink.url}
        >
          {financialAdviceLinks.bankingNavigationalLink.label} {arrowSVG()}
        </AllProductsButton>
      </TitleContainer>
      <LinksContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.financial_advice_navigation_links
                  .financial_advice_advice_services_title
              ]
            }
          </LinksColumnTitle>
          {financialAdviceLinks.adviceServicesLinks.map((adviceLink) => {
            return (
              <NavLink key={adviceLink.label} href={adviceLink.url}>
                {adviceLink.label}
              </NavLink>
            );
          })}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.financial_advice_navigation_links
                  .financial_advice_advice_goals_title
              ]
            }
          </LinksColumnTitle>
          {financialAdviceLinks.financialGoalsLinks.map(
            (financialGoalsLink) => {
              return (
                <NavLink
                  key={financialGoalsLink.label}
                  href={financialGoalsLink.url}
                >
                  {financialGoalsLink.label}
                </NavLink>
              );
            },
          )}
        </LinksSubContainer>
      </LinksContainer>
    </>
  );
};
